let url = '';
if (
  window.config.url.includes('https://dev.art.subjektiv.co.uk') ||
  window.config.url.startsWith('http://localhost:2368')
) {
  url = 'https://dev.api.main.subjektiv.co.uk';
} else if (window.config.url.includes('https://subjektiv.art')) {
  url = 'https://main.api.subjektiv.art';
}
if (!url) {
  console.warn(`Url is not valid '${window.config.url}'`);
}
export const config = {
  url,
};
